import type { LaneOverviewCard } from "../types"

/**
 * The lanes list's one filter, kept in the URL (`/voxlane/lanes?status=`)
 * so the sidebar and a shared link can open it. "attention" is the same
 * rule the sidebar's count uses: degraded or failed.
 */
export type LaneListFilter = "attention" | "provisioning"

export const LANE_LIST_FILTERS: Record<
  LaneListFilter,
  { label: string; empty: string; match: (lane: LaneOverviewCard) => boolean }
> = {
  attention: {
    label: "Lanes that need attention",
    empty: "None of your lanes are degraded or failed.",
    match: (lane) => lane.status === "degraded" || lane.status === "failed",
  },
  provisioning: {
    label: "Lanes being set up",
    empty: "No lanes are being set up right now.",
    match: (lane) => lane.status === "provisioning",
  },
}

export function parseLaneListFilter(value: unknown): LaneListFilter | undefined {
  return value === "attention" || value === "provisioning" ? value : undefined
}
